import * as React from "react";
import { cn } from "../../utils/cn";

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  testId?: string;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, testId, ...props }, ref) => {
    return (
      <input
        ref={ref}
        type={type}
        className={cn(
          "flex h-11 w-full rounded-md border border-input bg-background px-4 py-3 text-base text-foreground sm:text-sm ring-offset-background file:mr-3 file:rounded-sm file:border-0 file:bg-muted file:px-3 file:py-1.5 file:text-sm file:font-semibold file:text-foreground placeholder:text-muted-foreground focus:border-ring focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring/30 disabled:cursor-not-allowed disabled:opacity-50",
          className,
        )}
        data-testid={testId}
        {...props}
      />
    );
  },
);

Input.displayName = "Input";

const InputExample = () => {
  return (
    <div>
      <Input type="email" placeholder="Email" />
      <br />
      <p>
        For full documentation check{" "}
        <a
          className="underline"
          href="https://ui.shadcn.com/docs/components/input"
          target="_blank"
          rel="noreferrer"
        >
          Shadcn documentation
        </a>
      </p>
    </div>
  );
};

export { Input, InputExample };
